module.exports = __webpack_public_path__ + "img/no-job-selected-en.10aeae49.svg";